import * as THREE from 'three'
import { extend } from '@react-three/fiber'

class DofPointsMaterial extends THREE.ShaderMaterial {
  constructor() {
    super({
      vertexShader: `uniform sampler2D positions;
      uniform float uTime;
      uniform float uFocus;
      uniform float uFov;
      uniform float uBlur;
      varying float vDistance;
      void main() { 
        vec3 pos = texture2D(positions, position.xy).xyz;
        vec4 mvPosition = modelViewMatrix * vec4(pos, 1.0);
        gl_Position = projectionMatrix * mvPosition;
        vDistance = abs(uFocus - -mvPosition.z);

        float visibility =
          step(1.0 - (1.0 / uFov), position.x);

        float blurDistance =
          clamp(vDistance, 0.0, 4.0);

        gl_PointSize =
          visibility * max(1.0, blurDistance * uBlur);
      }`,
      fragmentShader: `uniform float uOpacity;
      varying float vDistance;
      void main() {
        vec2 point = 2.0 * gl_PointCoord - 1.0;
        float radius = dot(point, point);

        if (radius > 1.0) discard;

        float softEdge =
          1.0 - smoothstep(0.65, 1.0, radius);

        float distanceFade =
          mix(0.55, 0.08, smoothstep(0.0, 4.0, vDistance));

        gl_FragColor =
          vec4(vec3(1.0), softEdge * distanceFade);
      }`,
      uniforms: {
        positions: { value: null },
        uTime: { value: 0 },
        uFocus: { value: 5.1 },
        uFov: { value: 5 },
        uBlur: { value: 3 }
      },
      transparent: true,
      blending: THREE.NormalBlending,
      depthWrite: false
    })
  }
}

extend({ DofPointsMaterial })
